import React, { useState } from 'react';
import { 
  Card, 
  Form, 
  Select, 
  Button, 
  Input, 
  Breadcrumb,
  Typography,
  Row,
  Col
} from 'antd';
import { 
  ReloadOutlined,
  HomeOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;
const { Option } = Select;

const SupermarketInwardPage = ({ userdata }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Mock data for dropdowns
  const rackOptions = [
    { value: 'rack1', label: 'Rack 1' },
    { value: 'rack2', label: 'Rack 2' },
    { value: 'rack3', label: 'Rack 3' },
    { value: 'rack4', label: 'Rack 4' },
  ];

  const sewingLineOptions = [
    { value: 'line1', label: 'Line 1' },
    { value: 'line2', label: 'Line 2' },
    { value: 'line3', label: 'Line 3' },
    { value: 'line4', label: 'Line 4' },
  ];

  const handleNext = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      
      // Navigate to kanban plan sheet page with form data
      navigate('/kanban-plan-sheet', { 
        state: { 
          rack: values.rack,
          sewingLine: values.sewingLine,
          kanbanNumber: values.kanbanNumber
        }
      });
    } catch (error) {
      console.error('Form validation failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      padding: '0', 
      backgroundColor: '#f5f5f5', 
      minHeight: '100vh',
      margin: 0
    }}>
      {/* Header Bar */}
      {/* <div style={{
        height: '50px',
        backgroundColor: '#333333',
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        color: 'white'
      }}>
        <ReloadOutlined style={{ 
          fontSize: '18px', 
          marginRight: '12px',
          color: 'white'
        }} />
        <span style={{ 
          fontSize: '16px',
          fontWeight: '500',
          color: 'white'
        }}>
          Supermarket Inward
        </span>
      </div> */}

      {/* Navigation Bar
      <div style={{
        height: '40px',
        backgroundColor: '#e8e8e8',
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        borderBottom: '1px solid #d9d9d9'
      }}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <HomeOutlined style={{ marginRight: '4px' }} />
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item>Supermarket Inward</Breadcrumb.Item>
        </Breadcrumb>
      </div> */}

      {/* Main Content */}
      <div style={{
        padding: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minHeight: 'calc(100vh - 90px)'
      }}>
        <Card
          style={{
            width: '400px',
            backgroundColor: '#1e3a8a',
            border: 'none',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }}
          bodyStyle={{
            padding: '32px'
          }}
        >
          <Form
            form={form}
            layout="vertical"
            style={{ width: '100%' }}
          >
            {/* Select Rack */}
            <Form.Item
              label={
                <span style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>
                  Select Rack:
                </span>
              }
              name="rack"
              rules={[{ required: true, message: 'Please select a rack' }]}
              style={{ marginBottom: '24px' }}
            >
              <Select
                placeholder="Select Rack"
                style={{
                  height: '40px',
                  backgroundColor: 'white',
                  borderRadius: '4px'
                }}
                suffixIcon={<span style={{ color: '#666' }}>▼</span>}
              >
                {rackOptions.map(option => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {/* Select Sewing Line */}
            <Form.Item
              label={
                <span style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>
                  Select Sewing Line:
                </span>
              }
              name="sewingLine"
              rules={[{ required: true, message: 'Please select a sewing line' }]}
              style={{ marginBottom: '24px' }}
            >
              <Select
                placeholder="Select Line"
                style={{
                  height: '40px',
                  backgroundColor: 'white',
                  borderRadius: '4px'
                }}
                suffixIcon={<span style={{ color: '#666' }}>▼</span>}
              >
                {sewingLineOptions.map(option => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {/* Kanban Number */}
            <Form.Item
              label={
                <span style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>
                  Kanban Number:
                </span>
              }
              name="kanbanNumber"
              rules={[{ required: true, message: 'Please enter kanban number' }]}
              style={{ marginBottom: '32px' }}
            >
              <Input
                placeholder="Enter Kanban Number"
                style={{
                  height: '40px',
                  backgroundColor: 'white',
                  borderRadius: '4px',
                  border: '1px solid #d9d9d9'
                }}
              />
            </Form.Item>

            {/* Next Button */}
            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                onClick={handleNext}
                loading={loading}
                style={{
                  width: '100%',
                  height: '45px',
                  backgroundColor: '#1e3a8a',
                  border: '2px solid #dc2626',
                  borderRadius: '4px',
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#f97316',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#1d4ed8';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#1e3a8a';
                }}
              >
                &lt;&lt;&lt;&lt;&lt; Next &gt;&gt;&gt;&gt;&gt;
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default SupermarketInwardPage;


